.soundMeter {
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 16px;
}
